import { generateRequest } from './index';
import { toQueryString } from '../../lib/utils/querystring';

export const Action = {
  Analytics: {
    PerformFirstPartyTrackingPending: 'PerformFirstPartyTrackingPending',
    PerformFirstPartyTrackingCompleted: 'PerformFirstPartyTrackingCompleted',
    PerformFirstPartyTrackingFailed: 'PerformFirstPartyTrackingFailed',
  },
};

export const performFirstPartyTracking = event => generateRequest({
  endpoint: `/assets-v2/api/analytics/event?${toQueryString({
    eventType: event.event,
    eventSource: event.source,
  })}`,
  types: [
    Action.Analytics.PerformFirstPartyTrackingPending,
    Action.Analytics.PerformFirstPartyTrackingCompleted,
    Action.Analytics.PerformFirstPartyTrackingFailed,
  ],
});
